import { defaultLexicalTheme } from '../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/defaultLexicalTheme'

import './emailLexicalStyles.scss'

export const emailLexicalTheme = {
  ...defaultLexicalTheme,
  tableCell: 'email-lexical-table-cell',
}
